import { BlankSlate } from "@msuite/ui/blank-slate";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { useArticleImage } from "@/hooks/use-article-image";

/** Props Interface */
interface ArticleImageTileProps {
	articleId: string;
	alt: string;
}

/**
 * The article's picture. `process-article-files` centres every uploaded photo on a white square,
 * so it is drawn as a white square tile of a fixed size — stretched to its container's width it
 * would be letterboxed, and the white would show as a bar across a dark card. An article without
 * one says so in the same height, so whatever sits below stays in place once the picture loads.
 */
export function ArticleImageTile({ articleId, alt }: ArticleImageTileProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Query */
	const { imageUrl, isLoading } = useArticleImage(articleId);

	/** Render */
	return imageUrl ? (
		<img
			src={imageUrl}
			alt={alt}
			className="mx-auto size-48 object-contain rounded-base bg-white"
		/>
	) : (
		<BlankSlate
			className="h-48"
			Icon={icon("Image")}
			label={t("stock.article_has_no_image")}
			isLoading={isLoading}
			withAccessory={false}
		/>
	);
}
